<template>
<div>List of Sessions
  <div v-if="$apollo.queries.sessions.loading">Loading...</div>
<ul v-else>
  <li v-for="session in sessions.data" :key="session.id">
    {{session.title}}
  </li>
</ul>
</div>
</template>

<script>

import gql from 'graphql-tag';

export default {
  name: "test",
  apollo: {
    sessions: gql`
    query{
      sessions{
        data{
          title
          id
        }
      }
    }
    `


  }
}
</script>

<style scoped>

</style>